namespace com.enirva.util
{
	import Debugger = com.enirva.debug.Debugger;
	/*
	 * ユーザーエージェントクラス
	 */
	export class UserAgent
	{
		private static _instance:UserAgent;
		
		public isIOS:boolean;

		public isIPad:boolean;

		public isIE11:boolean;

		public ieVersion:number;

		public isAndroid:boolean;

		public isTablet:boolean;

		public isMac:boolean;

		public isSmartPhone:boolean;


		constructor()
		{
			var agent: string = navigator.userAgent;
			//console.log(agent);
			this.isIOS = agent.indexOf('iPhone') > -1 || agent.indexOf('iPod') > -1 || agent.indexOf('iPad') > -1;
			this.isAndroid = agent.indexOf('Android') > -1;
			this.isIPad = agent.indexOf('iPad') > -1;
			this.isMac = agent.indexOf('Mac') >= 0;

			if (agent.indexOf('iPhone') > 0 || agent.indexOf('iPod') > 0 || agent.indexOf('Android') > 0)
			{
				if (agent.indexOf('Mobile') < 0)
				{
					this.isTablet = true;
				}
			} 

			if (!this.isIOS && !this.isAndroid)
			{
				//PCの場合はAndroidをシミュレート
				//this.isIOS = true;
			}

			this.isSmartPhone = this.isIOS || this.isAndroid || this.isIPad;

			// Debugger.log("isIOS " + this.isIOS);
			// Debugger.log("isIPad " + this.isIPad);
			// Debugger.log("isAndroid " + this.isAndroid);
			// Debugger.log("isTablet " + this.isTablet);
			//this.isAndroid = false;
			//this.isIOS = true;

			this.isIE11 = (agent.toLowerCase().indexOf('trident/7') > -1);
		}


		public static get instance():UserAgent
		{
			if (UserAgent._instance == null)
			{
				UserAgent._instance = new UserAgent();
			}

			return UserAgent._instance;
		}
	}
}

